import styled from 'styled-components';
import { ChevronIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';

const ModalContainerStyled = styled.div`
  #divlivechat {
    height: calc(100% - 60px);
  }

  .modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10050;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    outline: 0;
    background: #fff;
    text-align: center;
  }

  .modal-header {
    padding: 16px 40px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    background: #270046;
    width: 100%;
    display: grid;
    grid-template-columns: auto 1fr;
  }

  .modal-close-button {
    font-size: 1.48rem;
    font-weight: 700;
    cursor: pointer;
    border: none;
    background: transparent;
  }

  button {
    border: none;

    &:focus {
      outline: none;
    }

    svg {
      margin-bottom: 4px;
    }
  }
  iframe {
    border: none;
    width: 100%;
    height: 100%;

    @media (min-width: 769px) {
      border-left: 1px solid gray;
      border-right: 1px solid gray;
      max-width: 768px;
      height: 100%;
    }
  }
  .hide {
    display: none;
  }
`;

const ChevronStyled = styled(ChevronIcon)`
  transform: rotate(90deg);

  path {
    fill: #fff;
  }
`;

const ModalTitleStyled = styled.div`
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  padding-right: 54px;
`;

const ButtonContainerStyled = styled.div`
  display: flex;
`;

export {
  ModalContainerStyled,
  ChevronStyled,
  ModalTitleStyled,
  ButtonContainerStyled,
};
